import vibrant from '../libs/vibrant.min.js';

export default () => {

    const sliderBg  = document.querySelectorAll('[change-bg]')

    if(!sliderBg) {
        return
    }
    
    sliderBg.forEach(slide => {
        let bgColor;
        if(slide.dataset.bg.length > 0){
           bgColor = slide.dataset.bg;
           
        } else {

            let img = slide.querySelector('img');

            if(!img || !img.src) {
                return
            }
            let vibrant;

            try {
                vibrant =  new Vibrant(img);
            } catch (error) {
                console.warn(error)
            }
            

            if(vibrant && vibrant.VibrantSwatch && vibrant.VibrantSwatch.getHex) {
                bgColor = vibrant.VibrantSwatch.getHex()
            }
        }
        slide.style.backgroundColor = bgColor;
    })
}